import React, {useState} from "react";
import styled from "styled-components/macro";
import * as Yup from "yup";
import {Formik} from "formik";

import {
    Alert as MuiAlert,
    Button,
    TextField as MuiTextField,
} from "@mui/material";
import {spacing} from "@mui/system";

import {useForgotPasswordMutation} from "../../graphql/auth/auth.graphql-gen";

const Alert = styled(MuiAlert)(spacing);

const TextField = styled(MuiTextField)<{ my?: number }>(spacing);

function ResetPassword() {

    const [message, setMessage] = useState('');
    const [forgotPassword] = useForgotPasswordMutation();

    return (
        <Formik
            initialValues={{
                email: "",
                submit: false,
            }}
            validationSchema={Yup.object().shape({
                email: Yup.string()
                    .email("Must be a valid email")
                    .max(255)
                    .required("Email is required"),
            })}
            onSubmit={async (values, {setErrors, setStatus, setSubmitting}) => {
                try {
                    forgotPassword({
                        variables: {email: values.email}
                    });
                    setMessage('Link for reset password is sent to your email')

                } catch (error: any) {
                    const message = error.message || "Something went wrong";

                    setStatus({success: false});
                    setErrors({submit: message});
                    setSubmitting(false);
                }
            }}
        >
            {({
                  errors,
                  handleBlur,
                  handleChange,
                  handleSubmit,
                  isSubmitting,
                  touched,
                  values,
              }) => (
                <form noValidate onSubmit={handleSubmit}>
                    {errors.submit && (
                        <Alert mt={2} mb={1} severity="warning">
                            {errors.submit}
                        </Alert>
                    )}
                    {message && (
                        <Alert mt={2} mb={1} severity="success">
                            {message}
                        </Alert>
                    )}
                    <TextField
                        type="email"
                        name="email"
                        label="Email Address"
                        value={values.email}
                        error={Boolean(touched.email && errors.email)}
                        fullWidth
                        helperText={touched.email && errors.email}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        my={3}
                    />
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        disabled={isSubmitting}
                    >
                        Reset password
                    </Button>
                </form>
            )}
        </Formik>
    );
}

export default ResetPassword;
